export const CONTACT = {
  email: "AlphaHouseDevelopment@gmail.com",
  phone: "(240) 363-9117",
  phoneHref: "tel:+12403639117",
  smsHref: "sms:+12403639117?&body=Hi%20Kenneth%2C%20I%20found%20Bossard%20Investment%20Group%20online%20and%20would%20like%20to%20learn%20more.",
  calendly: "https://calendly.com/kenbossard/15min",
  dbaUrl: "https://bossardhomes.com",
  dbaName: "Bossard Homes",
  legalName: "Bossard Investment Group LLC",
  location: "Laurel, Maryland",
  founded: "2022",
};

export const VIDEOS = {
  film: "https://www.youtube.com/embed/8PFNgiaVcsU?rel=0&modestbranding=1&color=white",
  pilot: "https://www.youtube.com/embed/nNOCL6_J0JM?rel=0&modestbranding=1&color=white",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1724027213513-ae1e313ddc33?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  estate: "https://images.unsplash.com/photo-1722139377627-223692f7ab72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV_LINKS = [
  { label: "The Film", href: "#film" },
  { label: "Approach", href: "#approach" },
  { label: "Services", href: "#services" },
  { label: "Private Lending", href: "/private-lending" },
  { label: "On Air", href: "#on-air" },
  { label: "Family", href: "#family" },
  { label: "Overview PDF", href: "#deck" },
  { label: "Contact", href: "#contact" },
];

export const LENDING = {
  intro:
    "Private lending lets you participate in real estate as the capital partner rather than the operator. You fund a specific property project; the property itself — not a promise — secures your position, and you earn interest for the use of your money.",
  howIntro:
    "Instead of buying, renovating and managing a property yourself, a private lender provides short-term capital to an operator who does. The loan is documented, recorded and tied to a real, inspected asset with a defined exit.",
  earn: [
    { title: "Interest Income", body: "Your return comes from the interest charged on the loan — typically paid monthly or accrued and paid at payoff, per the note." },
    { title: "Defined Term", body: "Private loans are short-term by design, structured around a renovation-and-exit timeline rather than a 30-year horizon." },
    { title: "Return of Principal", body: "At the exit — a sale or a refinance into long-term financing — the loan is paid off and your principal is returned." },
  ],
  securityIntro:
    "A well-structured private loan is protected by layers of documentation and collateral. These are the safeguards you should expect to see on any deal.",
  security: [
    { icon: "Home", title: "Recorded Lien", body: "A deed of trust or mortgage recorded against the property in your favor — your claim is public record, not a handshake." },
    { icon: "FileSignature", title: "Promissory Note", body: "The written contract that spells out the amount, rate, term, payment schedule and remedies if anything goes wrong." },
    { icon: "ShieldCheck", title: "Title & Hazard Insurance", body: "Lender's title insurance protects your lien position; property insurance lists you as loss payee." },
    { icon: "Scale", title: "Conservative Loan-to-Value", body: "Loans are sized against the property's conservatively estimated value, leaving an equity cushion beneath your position." },
    { icon: "Landmark", title: "Third-Party Closing", body: "Funds move through a title company or closing attorney — never directly to the operator." },
    { icon: "CalendarClock", title: "Transparent Servicing", body: "Regular renovation and timeline updates so you always know where the project — and your capital — stands." },
  ],
  process: [
    { title: "Introduction Call", body: "We learn your goals, timeline, capital source (cash, self-directed IRA, entity) and comfort with risk." },
    { title: "Opportunity Presentation", body: "When a project fits, you receive an underwriting package: property details, scope, comparable sales, budget and exit plan." },
    { title: "Documentation", body: "A closing attorney or title company prepares the note, deed of trust and lender's title policy for your review." },
    { title: "Funding at Closing", body: "You wire funds to the title company's escrow; the lien is recorded in your name at closing." },
    { title: "Renovation & Updates", body: "The operator executes the plan while you receive progress reports and scheduled interest payments as documented." },
    { title: "Payoff", body: "On sale or refinance, the title company pays off your note — principal plus any accrued interest — and releases the lien." },
  ],
  compare: [
    ["Role", "Capital partner", "Operator & owner"],
    ["Return source", "Interest on the note", "Rent, appreciation, tax benefits"],
    ["Time involvement", "Review documents, receive payments", "Renovation, tenants, management"],
    ["Position", "Secured lien, ahead of equity", "Equity, behind lenders"],
    ["Upside", "Fixed, defined by the note", "Uncapped, tied to the market"],
    ["Horizon", "Short term, defined exit", "Long term, owner's discretion"],
  ],
  risks: [
    "A borrower may default or fall behind, requiring collection or foreclosure.",
    "Renovations can run over budget or behind schedule, delaying payoff.",
    "Property values can decline, reducing the equity cushion beneath your lien.",
    "Private loans are illiquid — capital is committed until payoff.",
    "Title, insurance, permitting or legal issues can affect the project.",
    "Loan documents, lien position and insurance must be independently reviewed.",
  ],
  disclaimer:
    "This page is educational and is not an offer to sell or a solicitation to buy any security or loan. Any private lending relationship with Bossard Investment Group LLC is structured case-by-case, documented separately, and may be limited to accredited or sophisticated investors in compliance with applicable securities laws. Returns are not guaranteed. Consult your legal, tax and financial advisors.",
};

export const CHAPTERS = [
  {
    num: "01",
    title: "Source",
    body: "We identify distressed, vacant, estate, tired-landlord and value-add properties across DC, Maryland and Virginia — pairing traditional valuation with AI-assisted screening to surface what the market overlooks.",
  },
  {
    num: "02",
    title: "Underwrite",
    body: "Comparable sales, rent assumptions, renovation scope, preliminary ARV and the most likely financing path are modeled before an opportunity ever reaches you.",
  },
  {
    num: "03",
    title: "Control",
    body: "Selected opportunities are placed under contract. We coordinate inspections, contractor renovation estimates and due diligence so nothing is left to guesswork.",
  },
  {
    num: "04",
    title: "Assign",
    body: "Qualified contracts may be assigned to investor clients. Kenneth Bossard assists with mortgage financing options — turning a deal into a holding.",
  },
];

export const SERVICES = [
  {
    title: "Acquisition Sourcing",
    body: "Professionally sourced, off-market and value-add opportunities with BRRRR potential across the DMV.",
    icon: "Search",
    featured: true,
  },
  {
    title: "Private Lending",
    body: "Relationship-driven private lending structures for investors seeking real-estate-backed income.",
    icon: "Landmark",
    link: "/private-lending",
  },
  {
    title: "Renovation Strategy",
    body: "Scope, budget and contractor coordination designed around resale value and rent-ready timelines.",
    icon: "Hammer",
  },
  {
    title: "Turnkey BRRRR Concierge",
    body: "Buy, rehab, rent, refinance, repeat — managed end-to-end for professionals who want the asset, not the second job.",
    icon: "KeyRound",
  },
  {
    title: "Mortgage Financing Support",
    body: "Financing guidance from Kenneth Bossard for qualified borrowers, subject to lender guidelines.",
    icon: "Percent",
  },
  {
    title: "Wealth Planning",
    body: "Understand how real estate creates income, equity, tax benefits and generational wealth.",
    icon: "TrendingUp",
  },
];

export const FAQS = [
  {
    q: "Who is the investor program designed for?",
    a: "High-income, time-constrained professionals — physicians, attorneys, executives, engineers, tech professionals, business owners and government leaders — who want guided access to investment property without hunting for deals themselves.",
  },
  {
    q: "What is a BRRRR investment?",
    a: "Buy, Rehab, Rent, Refinance, Repeat. We source undervalued properties, coordinate renovation, stabilize them with tenants, and help you refinance to recycle capital into the next asset.",
  },
  {
    q: "Are returns guaranteed?",
    a: "No. Real estate investing involves market, renovation, financing, tenant, insurance, title, appraisal and refinance risk. All projections should be independently verified with your legal, tax and financial advisors.",
  },
  {
    q: "How does private lending work with Bossard Investment Group?",
    a: "Private lending relationships are structured case-by-case and documented separately. Schedule an introduction call to discuss terms, security and expectations.",
  },
  {
    q: "Can Kenneth Bossard provide financing?",
    a: "Kenneth Bossard can help qualified borrowers review mortgage financing options. All loans are subject to lender guidelines, underwriting, property eligibility and borrower qualification.",
  },
];

export const INTERESTS = [
  "Investor Program",
  "Private Lending",
  "Sell a Property",
  "Mortgage Financing",
  "Media & Speaking",
  "Other",
];
